import React from "react";
import * as ReactDOMServer from "react-dom/server";
import styled from "styled-components";
import FallbackClassImg from "assets/fallback.png";
import { defaultThemeColors, fonts, mediaSizes } from "ui/theme";
import { StarFullIcon } from "ui/icons";

export const MarkerClassCard = ({ zoomLevel, classData }) => {
    if (zoomLevel > 12) {
        return ReactDOMServer.renderToString(
            <Container>
                <ImageContainer>
                    {classData?.img ? (
                        <Img src={classData.img} />
                    ) : (
                        <Img src={FallbackClassImg} />
                    )}
                </ImageContainer>

                <TextContainer>
                    <TitleText>{classData.title}</TitleText>
                    <RatingText>
                        <p className='rating'>
                            <StarFullIcon />
                            {Number(classData?.rate || 0).toFixed(1)}
                        </p>
                        <p className='review'>({classData?.review || 0} reviews)</p>
                    </RatingText>
                    <PricingDetails>
                        <span>
                            {`From $${classData?.price} / person`}
                        </span>
                    </PricingDetails>
                </TextContainer>
            </Container>
        );
    }
    return ReactDOMServer.renderToString(<Dot />);
};

const Dot = styled.div`
    width: 20px;
    height: 20px;
    border-radius: 10px;
    background-color: #554df1;
    border: solid 2px #ffffff;
`;

const Container = styled.div`
    display: flex;
    gap: 3px;
    background-color: white;
    padding: 5px;
    width: 70px;
    height: 70px;
    border-radius: 5px;
    z-index: 1;
    transition: width 0.3s ease-out;
    overflow: hidden;

    &:hover {
        z-index: 10;
        width: 208px;
        transform: scale(1.2);
    }
`;

const ImageContainer = styled.div`
    width: 59px;
    border-radius: 5px;
`;

const Img = styled.img`
    width: 59px;
    height: 100%;
    object-fit: cover;
    border-radius: 5px;
    aspect-ratio: 1/1;
`;

const TextContainer = styled.div`
    width: 100%;
    min-width: 80px;
    white-space: nowrap;
    display: flex;
    /* gap: 5px; */
    flex-direction: column;
    justify-content: center;
    overflow: hidden;

    margin-left: 8px;
`;

const RatingText = styled.div`
    font-weight: 500;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: ${fonts.sizes.extraSmall};
    font-weight: 500;

    & > .rating {
        display: flex; 
        align-items: center;
        gap: 0.2rem;
        color: ${defaultThemeColors.pink};

        & > svg {
            width: 0.85rem;
            height: 0.85rem;
        }
    }

    & > .review {
        color: ${defaultThemeColors.txt};
        opacity: 0.6;
    }
`

const TitleText = styled.p`
    font-size: 12px;
    font-weight: 600;
    width: 100%;
    /* overflow: hidden; */
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
`;

const PricingDetails = styled.p`
    font-weight: 500;
    color: ${defaultThemeColors.txt};
    font-size: 12px;

    & > :nth-child(2) {
        opacity: 0.6;
    }
`;